































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { noAbc, nextInput, inputFixed } from '@/modules/budget/monitoring/input-forms/common/formaters';
import { hasUnfilledReason, isYearMissing, deviation as calcDeviation } from '@/modules/budget/monitoring/input-forms/components/application41/deviationValidation';

@Component({})
export default class TargetIndicators extends Vue {
    @Prop({ required: true, default: () => ({}) })
    private currBipForm!: any;
    @Prop({ required: true, default: '' })
    private tr_path!: string;
    @Prop({ required: true, default: () => ({}) })
    private currForm!: any;
    // NTF.eAk.APPL41.01 — включает подсветку полей причины отклонения после неудачной
    // попытки сохранения (см. application_41.vue, saveData).
    @Prop({ required: false, default: false })
    private validationActive!: boolean;
    // Право редактирования карточки (application_41.vue -> FormData.vue) — определяет
    // карандаш/глазик у наименования конечного результата и доступность полей/кнопки
    // "Сохранить" в модалке (см. openResultNameModal/saveResultNameModal).
    @Prop({ required: false, default: false })
    private editAccess!: boolean;

    // ЦИ приходят с бэка в currBipForm.target_indicators (get_app41_target_indicators,
    // §9 ТЗ) — список подтянутых секций, доля/факт/причина/конечные результаты
    // сохраняются через /gip-forms/save (save_target_indicators, Application41TargetIndicators).
    private get targetIndicators(): any[] {
        return (this.currBipForm && this.currBipForm.target_indicators) || [];
    }

    // Числовые поля (доля/факт ЦИ, план/факт конечного результата по годам) —
    // тот же форматтер ввода, что и в application12_14.vue: noAbc блокирует нецифровые
    // символы по keypress, nextInput переводит фокус на следующее поле по Enter.
    private noAbc: Function = noAbc;
    private nextInput: Function = nextInput;
    private inputFixed: Function = inputFixed;

    // Год конечного результата — селектор (vue-multiselect); список лет ограничен
    // плановым периодом реализации проекта (currBipForm.impl_period, "YYYY - YYYY" —
    // тот же формат, что и графа 19, см. get_gip_forms/step1_query), RQ.eAk.APPL41.23.
    // Если период не задан/некорректен (например, строка-«призрак», is_deleted_from_plan —
    // см. _build_row_from_saved), год ничем не ограничен — используется широкий диапазон.
    private get yearOptions(): number[] {
        const period = this.currBipForm && this.currBipForm.impl_period;
        const parts = String(period || '').split('-').map((s: string) => parseInt(s.trim(), 10));
        const [from, to] = parts;
        const years: number[] = [];
        if (!isNaN(from) && !isNaN(to) && to >= from) {
            for (let y = from; y <= to; y++) years.push(y);
            return years;
        }
        for (let y = 2019; y <= 2019 + 10; y++) years.push(y);
        return years;
    }

    // RQ.eAk.APPL41.49 — год в пределах одного конечного результата должен быть
    // уникален: список для конкретной строки (y) исключает года, уже занятые ДРУГИМИ
    // строками этого же результата (res), но оставляет собственный текущий год y.
    private availableYears(res: any, y: any): number[] {
        const used = new Set(
            (res.years || [])
                .filter((yy: any) => yy !== y)
                .map((yy: any) => yy.year)
                .filter((v: any) => v !== null && v !== undefined)
        );
        return this.yearOptions.filter((year: number) => !used.has(year));
    }

    // Кнопка «Добавить год» скрыта, когда строк уже столько же, сколько допустимых лет.
    private canAddYear(res: any): boolean {
        return (res.years || []).length < this.yearOptions.length;
    }

    // Подсветка дубля — на случай ранее сохранённых данных (до появления availableYears)
    // или гонки при параллельном редактировании; сам выбор дублей выше уже не допускает.
    private duplicateYear(res: any, y: any): boolean {
        if (y.year === null || y.year === undefined) return false;
        return (res.years || []).some((yy: any) => yy !== y && yy.year === y.year);
    }

    // У одного ГИП может быть несколько БИП (currBipForm.bip_code — список) — метку
    // БИП у секции ЦИ показываем только когда их правда несколько, иначе она лишняя.
    private get hasMultipleBip(): boolean {
        const codes = this.currBipForm && this.currBipForm.bip_code;
        return Array.isArray(codes) && codes.length > 1;
    }

    // Состояние аккордеона — чисто UI, живёт отдельно от данных, по индексу в списке
    private collapsedState: Record<number, boolean> = {};

    private isCollapsed(idx: number): boolean {
        return !!this.collapsedState[idx];
    }

    private toggle(idx: number) {
        this.$set(this.collapsedState, idx, !this.collapsedState[idx]);
    }

    // Наименование ЦИ / документ СГП / направление / цель / единица измерения —
    // Подтягивается (RQ.eAk.APPL41.17-18), локаль ru/kk с фолбэком на ru.
    private localized(ti: any, key: string): string {
        if (!ti) return '';
        return ti[`${key}_${this.$i18n.locale}`] || ti[`${key}_ru`] || '';
    }

    private directionGoal(ti: any): string {
        const direction = this.localized(ti, 'direction');
        const goal = this.localized(ti, 'goal');
        return [direction, goal].filter(Boolean).join(' — ');
    }

    // «Доля проекта в ЦИ» (гр.6) — процент в диапазоне 0..100.
    // v-model.lazy успевает записать введённое в ti.share ДО этого обработчика
    // (оба на 'change', v-model в разметке стоит раньше): приводим строку к числу
    // (запятая → точка) и ограничиваем диапазон.
    private clampShare(ti: any) {
        inputFixed(ti, 'share', ti.share, 3, false, null);
        if (ti.share > 100) {
            ti.share = 100;
        } else if (ti.share < 0) {
            ti.share = 0;
        }
    }

    // План (система) — budget_request_bp_dri.plan_period1 (плановый период,
    // соответствующий году отчётного фильтра), считается на бэке в get_app41_target_indicators.
    private planSystemText(ti: any): string {
        const plan = (ti && ti.plan !== null && ti.plan !== undefined) ? Number(ti.plan) : null;
        const unit = this.localized(ti, 'unit');
        if (plan === null) return unit;
        return unit ? `${unit} ${plan.toLocaleString('ru-RU')}` : plan.toLocaleString('ru-RU');
    }

    private makeResult() {
        return { name_ru: '', name_kk: '', years: [this.makeYear()] };
    }

    private makeYear() {
        return { year: null, plan: '', fact: '', deviation_reason: '' };
    }

    private addResult(ti: any) {
        if (!ti.final_results) {
            this.$set(ti, 'final_results', []);
        }
        ti.final_results.push(this.makeResult());
    }

    private removeResult(ti: any, ri: number) {
        ti.final_results.splice(ri, 1);
    }

    // Наименование конечного результата — модалка с полями "На русском"/"На казахском"
    // (по карандашу/глазику у res). Значения хранятся в модалке ЛОКАЛЬНО (valueRu/valueKk)
    // до нажатия "Сохранить" — правки применяются к res только там (saveResultNameModal),
    // "Отмена"/закрытие крестиком их отбрасывает.
    private resultNameModal: { visible: boolean; target: any; valueRu: string; valueKk: string } = {
        visible: false,
        target: null,
        valueRu: '',
        valueKk: '',
    };

    private resultNameDisplay(res: any): string {
        return this.localized(res, 'name');
    }

    private openResultNameModal(res: any) {
        this.resultNameModal = {
            visible: true,
            target: res,
            valueRu: res.name_ru || '',
            valueKk: res.name_kk || '',
        };
    }

    private saveResultNameModal() {
        if (this.resultNameModal.target) {
            this.$set(this.resultNameModal.target, 'name_ru', this.resultNameModal.valueRu);
            this.$set(this.resultNameModal.target, 'name_kk', this.resultNameModal.valueKk);
        }
        this.resultNameModal.visible = false;
    }

    private closeResultNameModal() {
        this.resultNameModal.visible = false;
    }

    private addYear(res: any) {
        res.years.push(this.makeYear());
    }

    private removeYear(res: any, yi: number) {
        res.years.splice(yi, 1);
    }

    private t(key: string) {
        return this.$t(`${this.tr_path}target_ind.${key}`);
    }

    private toNumber(v: any): number {
        if (v === null || v === undefined || v === '') return 0;
        const n = Number(String(v).replace(/\s|%/g, '').replace(',', '.'));
        return isNaN(n) ? 0 : n;
    }

    // RQ.eAk.APPL41.19/.26 — отклонение = факт - план; при отсутствии факта не
    // считается (null, а не 0) — общая функция для всего модуля (deviationValidation.ts),
    // чтобы отображение и блокирующая валидация (findDeviationIssues) не расходились.
    private dev(plan: any, fact: any): number | null {
        return calcDeviation(plan, fact);
    }

    private devText(plan: any, fact: any): string {
        const d = this.dev(plan, fact);
        if (d === null) return '';
        const abs = Math.abs(d).toLocaleString('ru-RU');
        return d < 0 ? `- ${abs}` : `${abs}`;
    }

    private nt(key: string) {
        return this.$t(`${this.tr_path}notifications.${key}`);
    }

    // NTF.eAk.APPL41.01 — доля/факт ЦИ (ti.plan/ti.fact) отклоняются, а причина не
    // указана; при отсутствии факта (dev === null) отклонения нет — причина не нужна.
    private tiInvalid(ti: any): boolean {
        const d = this.dev(ti.plan, ti.fact);
        return d !== null && d !== 0 && hasUnfilledReason(ti.deviation_reason);
    }

    // Текст «Необходимо указать причину» показывается в тех же случаях, что и красная
    // рамка: после попытки сохранения (validationActive) либо при срабатывании
    // флк-валидатора ГИП (red-рамка validation_error от него не зависит от validationActive).
    private tiReasonMissing(ti: any): boolean {
        return this.tiInvalid(ti) && (this.validationActive || !!this.currBipForm.flk_target_indicators_deviation);
    }

    // Год обязателен: подсветка и текст сразу, как только в строке без года есть
    // план, факт или причина (не дожидаясь попытки сохранения).
    private yearMissing(y: any): boolean {
        return isYearMissing(y);
    }

    private yearReasonMissing(y: any): boolean {
        return this.yearInvalid(y) && (this.validationActive || !!this.currBipForm.flk_target_indicators_deviation);
    }

    // NTF.eAk.APPL41.01 / RQ.eAk.APPL41.27 — план/факт конечного результата по
    // конкретному году; причина обязательна только при отклонении ≠ 0.
    private yearInvalid(y: any): boolean {
        const d = this.dev(y.plan, y.fact);
        return d !== null && d !== 0 && hasUnfilledReason(y.deviation_reason);
    }
}
